// Package-application API client (Insurance Claims Phase 6.2/6.3) —
// admission-scoped, mounted under /api/ip (backend/routes/ip/admission-
// record.js, right beside the coverage/payer endpoints coverageApi.ts
// already wraps), not /api/claims. Kept in the claims feature folder for
// the same reason coverageApi.ts gives: the design doc treats this as part
// of the claims domain even though it hangs off `/ip`.
//
// `AdmissionPackage`/`Package` live in features/admin/types.ts (the
// package CATALOG's own home, alongside PayerTariff) — same cross-feature
// import CoveragePanel.tsx already does for `Payer`.
import { api } from '@/lib/api/client';
import type { AdmissionPackage } from '@/features/admin/types';

export function fetchAdmissionPackages(admissionId: number): Promise<AdmissionPackage[]> {
  return api.get(`/ip/admissions/${admissionId}/package`);
}

/** The route's own 201 response is `{...admission_packages row, package, charge}`,
 * not the flattened `AdmissionPackage` shape `fetchAdmissionPackages` returns —
 * callers should re-read the list (the mutation hook invalidates it) rather
 * than render straight off this result. */
export function applyPackage(admissionId: number, packageId: number): Promise<{ id: number }> {
  return api.post(`/ip/admissions/${admissionId}/package`, { package_id: packageId });
}

export function removePackage(admissionId: number, packageApplicationId: number): Promise<void> {
  return api.delete(`/ip/admissions/${admissionId}/package/${packageApplicationId}`);
}
